<template>
    <div class="user-block">
        <h3>Inspection Emails</h3>
        <div>
            <div class="form-row agent-fees">
                <b-form-group class="col-md-12">
                    <div class="container">
                        <template v-if="inspectionEmails.length">
                            <template v-for="(inspection, index) in inspectionEmails">
                                <div class="row">
                                    <b-form-group class="col-md-4">
                                        <label :for="`name-${index}`">Name</label>
                                        <b-form-input
                                            :id="`name-${index}`"
                                            class="w-100 mt-1"
                                            type="text"
                                            v-model="inspection.name"
                                            @input="emitInput"
                                        ></b-form-input>
                                    </b-form-group>
                                    <b-form-group class="col-md-4">
                                        <label :for="`email-${index}`">Email</label>
                                        <b-form-input
                                            :id="`email-${index}`"
                                            class="w-100 mt-1"
                                            type="email"
                                            v-model="inspection.email"
                                            @input="emitInput"
                                        ></b-form-input>
                                    </b-form-group>
                                    <div class="col-3">
                                        <b-btn class="btn mt-2 mt-sm-0"
                                               @click="removeInspectionEmail(index)">Remove
                                        </b-btn>
                                    </div>
                                </div>
                                <div v-if="inspectionEmailErrors[index] && inspectionEmailErrors[index].length" class="row align-items-center">
                                    <div class="alert alert-danger">
                                        <div v-for="err in inspectionEmailErrors[index]">- {{ err }}</div>
                                    </div>
                                </div>
                            </template>
                        </template>

                        <div class="isolated-add-button row">
                            <div class="col-md-12">
                                <b-btn @click="addInspectionEmail">Add New</b-btn>
                            </div>
                        </div>
                    </div>
                </b-form-group>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'underscore'
export default {
    name: "InspectionEmails",
    props: {
        value: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: () => {
        return {
            inspectionEmails: [],
            inspectionEmailErrors: {},
        }
    },

    mounted() {
        this.inspectionEmails = this.value
    },

    methods: {
        addInspectionEmail() {
            this.inspectionEmails.push({id: null, name: '', email: ''})
        },

        inspectionFieldState(index) {
        },

        validateField(index) {
            let errors = []
            if (!this.inspectionEmails[index].name || !this.inspectionEmails[index].name.length) {
                errors.push('Name field is required');
            }

            if (!this.inspectionEmails[index].email || !this.inspectionEmails[index].email.length) {
                errors.push('Email field is required');
            } else if (!this.inspectionEmails[index].email.toLowerCase().match(
                /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )) {
                errors.push('Email is invalid');
            }


            if (errors.length) {
                this.inspectionEmailErrors[index] = errors
            }
        },

        emitInput: _.debounce(function() {
            this.inspectionEmailErrors = {}
            for (let i = 0; i < this.inspectionEmails.length; i++) {
                this.validateField(i)
            }

            if(!Object.keys(this.inspectionEmailErrors).length) {
                this.$emit('input', this.inspectionEmails)
            }
        }, 200),

        removeInspectionEmail(index) {
            if(this.inspectionEmails[index].id !== null) {
                this.$emit('inspection-email-deleted', this.inspectionEmails[index].id)
            }
            this.inspectionEmails.splice(index, 1);
        }

    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/js/components/User/InspectionEmails.vue